module.exports = __webpack_public_path__ + "img/11.52daa88e.gif";